import { render, staticRenderFns } from "./CompaniesHome.vue?vue&type=template&id=9a8a64ce&scoped=true&"
import script from "./CompaniesHome.vue?vue&type=script&lang=js&"
export * from "./CompaniesHome.vue?vue&type=script&lang=js&"
import style0 from "./CompaniesHome.vue?vue&type=style&index=0&id=9a8a64ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8a64ce",
  null
  
)

export default component.exports